<template>

    <v-menu bottom close-on-click offset-y content-class="menu-style">
      <template #activator="{ on, attrs }">
        <slot name="activator" :on="on" :attrs="attrs"/>
      </template>
      <v-card>
        <v-subheader class="menu-subheader">{{ headerText }}</v-subheader>
        <v-card-text overflow-y-auto class="scrollable-card-text">
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="`${item.title}-${index}`"
              class="menu-list-item"
            >
              <v-list-item-icon>
                <v-icon color="primary" class="mt-2">{{ item.iconLeft }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                <div class="menu-date font-weight-bold text--black-3 mb-2">{{ item.date }}</div>
                <div class="menu-description font-weight-regular text--black-1 mb-1">{{ item.description }}</div>
                <div>
                  <v-btn
                    outlined
                    color="primary"
                    class="button-link"
                    :ripple="false"
                    depressed
                    small
                    @click="$emit('click', item);"
                    >{{ $t(item.linkText) }}</v-btn
                  >
                </div>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon>{{ item.iconRight }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
</template>

<script>
export default {
  name: 'BaseDropdownMenu',
  props: {
    headerText: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      validator: (items) => items.every((item) => (
        'iconLeft' in item
          && 'title' in item
          && 'date' in item
          && 'description' in item
          && 'link' in item
          && 'linkText' in item
          && 'iconRight' in item
          && 'id' in item
      )),
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-subheader {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.menu-style {
  border-radius: 1px !important;
  max-width: 350px !important;
}

.scrollable-card-text {
  max-height: 300px;
  padding: 0px;
}

:deep(.v-list-item__title) {
  font-size: 20px;
  font-weight: 400;
}

.menu-date {
  font-size: 12px;
}

.menu-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.menu-description {
  font-size: 12px;
}

:deep(.v-btn.button-link) {
  text-transform: none;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  letter-spacing: 0px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
